"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToTop = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var useScrollToTop = function () {
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    react_1.default.useEffect(function () {
        window.scrollTo(0, 0);
    }, [pathname]);
};
exports.useScrollToTop = useScrollToTop;
